/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { SolutionStatusOnlyDtoModel, SolutionStatusOnlyDtoModelType } from "./SolutionStatusOnlyDtoModel"
import { SolutionStatusOnlyDtoModelSelector } from "./SolutionStatusOnlyDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  pendingSolution: SolutionStatusOnlyDtoModelType;
}

/**
 * ProjectStopUnscheduledDtoBase
 * auto generated base class for the model ProjectStopUnscheduledDtoModel.
 *
 * Stop unscheduled
 */
export const ProjectStopUnscheduledDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('ProjectStopUnscheduledDto')
  .props({
    __typename: types.optional(types.literal("ProjectStopUnscheduledDto"), "ProjectStopUnscheduledDto"),
    pendingSolution: types.union(types.undefined, MSTGQLRef(types.late((): any => SolutionStatusOnlyDtoModel))),
    success: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class ProjectStopUnscheduledDtoModelSelector extends QueryBuilder {
  get success() { return this.__attr(`success`) }
  pendingSolution(builder: string | SolutionStatusOnlyDtoModelSelector | ((selector: SolutionStatusOnlyDtoModelSelector) => SolutionStatusOnlyDtoModelSelector) | undefined) { return this.__child(`pendingSolution`, SolutionStatusOnlyDtoModelSelector, builder) }
}
export function selectFromProjectStopUnscheduledDto() {
  return new ProjectStopUnscheduledDtoModelSelector()
}

export const projectStopUnscheduledDtoModelPrimitives = selectFromProjectStopUnscheduledDto().success
